'use client'

import { useReactiveDeleteCookie, useReactiveGetCookie, useReactiveSetCookie } from 'cookies-next'
import { useState } from 'react'

const MARKETING_COOKIE_BANNER_HIDDEN = 'preheader_hidden_login'
const MARKETING_COOKIE_BANNER_MAX_AGE = 60 * 60 * 24 * 365

export function useSetMarketingBannerVisible() {
  const setCookie = useReactiveSetCookie()
  const deleteCookie = useReactiveDeleteCookie()
  const [isVisible, setIsVisible] = useState(true)

  const setMarketingBannerVisible = (visible: boolean) => {
    setIsVisible(visible)

    if (visible) {
      deleteCookie(MARKETING_COOKIE_BANNER_HIDDEN)
    } else {
      setCookie(MARKETING_COOKIE_BANNER_HIDDEN, 'true', { maxAge: MARKETING_COOKIE_BANNER_MAX_AGE })
    }
  }

  return {
    isVisible,
    setMarketingBannerVisible,
  }
}

export function useIsMarketingBannerVisible() {
  const getCookie = useReactiveGetCookie()

  return () => {
    return getCookie(MARKETING_COOKIE_BANNER_HIDDEN) === 'true'
  }
}
